import type { ReactNode } from 'react'
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet'
import { cn } from '@/lib/utils'

/** The demo's right-hand work drawer: a titled header bar over a full-height body. */
export function EditorDrawer({
  open,
  title,
  wide = false,
  onOpenChange,
  children,
}: {
  open: boolean
  title: string
  wide?: boolean
  onOpenChange: (open: boolean) => void
  children: ReactNode
}) {
  return (
    <Sheet onOpenChange={onOpenChange} open={open}>
      <SheetContent
        aria-describedby={undefined}
        className={cn('flex w-[min(94vw,540px)] flex-col gap-0 p-0 sm:max-w-none', wide && 'w-[min(98vw,860px)]')}
      >
        <div className="flex min-h-14 shrink-0 items-center border-b px-5 pr-12">
          <SheetTitle className="text-base">{title}</SheetTitle>
        </div>
        {children}
      </SheetContent>
    </Sheet>
  )
}

export function DrawerFooter({ children }: { children: ReactNode }) {
  return <div className="flex shrink-0 flex-wrap justify-end gap-2 border-t px-5 py-4">{children}</div>
}
